module.exports = __webpack_public_path__ + "img/polanka.6794b526.jpg";